import { AnnouncementDetailEntitiesState } from './announcement-detail-entities.state';
import { announcementDetailEntitiesAdapter } from './announcement-detail-entities.adapter';

/**
 * Initialer State für Announcement-Detail-Entities.
 */
export const announcementDetailEntitiesStateInitial: AnnouncementDetailEntitiesState =
  announcementDetailEntitiesAdapter.getInitialState({
    isLoadingDetail: false,
    isDetailLoaded: false,
    detailError: null,
  });
